export default __webpack_public_path__ + "static/media/checklist.32a425c2.svg";